import React from 'react';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';
import { isNumber } from 'lodash';

const Stat = ({ amount, description, progress }) => {
	return (
		<div className="text-center">
			{/* Show progres if loading stat */}
			<Show if={progress}>
				<Icon
					icon="sync"
					className="animate-spin text-3xl text-neutral-300 dark:text-neutral-600"
				/>
			</Show>

			{/* Show amount if loaded */}
			<Show if={!progress}>
				<div className="text-3xl font-bold text-neutral-800 dark:text-white transition-colors">{amount}</div>
			</Show>

			<div className="text-sm text-neutral-500 dark:text-neutral-400 transition-colors">{description}</div>
		</div>
	);
};

export default Stat;